export const GET_WORKFLOWS = '@@workflowadmin/GET_WORKFLOWS';
export const LOAD_KEYWORDS_INTO_STORE =
  '@@workflowadmin/LOAD_KEYWORDS_INTO_STORE';
export const SET_APP_SETTING = '@@workflowadmin/GET_DRIVER_HELD_DAYS';
